export interface StockIndex {
  label: string;
  value: string;
  type: string;
}

export const STOCK_INDEXES: StockIndex[] = [
  {
    label: "Indikation auf Germany 40",
    value: "DE000A4AJCP5",
    type: "market",
  },
  {
    label: "Indikation auf Germany Tech 30",
    value: "DE000A4AJDG2",
    type: "market",
  },
  {
    label: "Indikation auf Germany Mid Cap",
    value: "DE000A4AJC07",
    type: "market",
  },
  {
    label: "Indikation auf Germany Small Caps",
    value: "DE000A4AJDB3",
    type: "market",
  },
  {
    label: "Indikation auf Eurozone 50",
    value: "DE000A4AJCR1",
    type: "market",
  },
  { label: "Indikation auf US 30", value: "DE000A4AJCQ3", type: "market" },
  {
    label: "Indikation auf US Tech 100",
    value: "DE000A4AJC49",
    type: "market",
  },
  { label: "Indikation auf US 500", value: "DE000A4AJC80", type: "market" },
  {
    label: "Indikation auf World Index",
    value: "DE000A4AJC31",
    type: "market",
  },
  {
    label: "Indikation auf Japan 225",
    value: "DE000A4AJC56",
    type: "market",
  },
  { label: "Indikation auf UK 100", value: "DE000A4AJCT7", type: "market" },
];

export const QUOTE_PROVIDERS = {
  ariva: "ariva",
  yahoo: "yf",
  ing: "ing",
  none: "none",
  quandl: "quandl",
  rentablo: "rentablo",
  crypto: "crypto",
  onvista: "ovfs",
};

export const ROLE_MANDATOR_LEVEL_STATISTICS_VIEWER =
  "ROLE_MANDATOR_LEVEL_STATISTICS_VIEWER";
export const ROLE_CROSS_MANDATOR_STATISTICS_VIEWER =
  "ROLE_CROSS_MANDATOR_STATISTICS_VIEWER";
export const ROLE_MASTER_DATA_ADMIN = "ROLE_MASTER_DATA_ADMIN";
export const ROLE_BANKING_API_LOGS_VIEWER = "ROLE_BANKING_API_LOGS_VIEWER";
export const ROLE_MULTIBANKING_API_ADMIN = "ROLE_MULTIBANKING_API_ADMIN";
export const ROLE_FINAPI_MANDATOR_ADMIN = "ROLE_FINAPI_MANDATOR_ADMIN";
export const ROLE_SAAS_ACCOUNTING = "ROLE_SAAS_ACCOUNTING";
export const ROLE_REGULATORY_REPORTING = "ROLE_REGULATORY_REPORTING";
export const ROLE_FINANCIAL_AUDITOR = "ROLE_FINANCIAL_AUDITOR";
export const ROLE_CROSS_MANDATOR_BANKING_API_LOGS_VIEWER =
  "ROLE_CROSS_MANDATOR_BANKING_API_LOGS_VIEWER";
export const ROLE_SUBSCRIPTION_ADMIN = "ROLE_SUBSCRIPTION_ADMIN";

// Pins the enum values the backends may return, sent with every request.
// Bumping it opts into every enum introduced since — see "Enum compatibility
// version" in the API description.
export const ENUM_COMPATIBILITY_VERSION = "v_2026_09_23";
export const ROLE_MANDATOR_VIEWER = "ROLE_MANDATOR_VIEWER";
export const ROLE_QUALITY_ASSURANCE = "ROLE_QUALITY_ASSURANCE";

// User management roles (mirror the backend @Secured annotations on the
// v1/users and v1/roles endpoints — keep these in sync with the API).
export const ROLE_USER_MANAGEMENT = "ROLE_USER_MANAGEMENT";
export const ROLE_USER_VIEWER = "ROLE_USER_VIEWER";
export const ROLE_CROSS_MANDATOR_USER_VIEWER =
  "ROLE_CROSS_MANDATOR_USER_VIEWER";
export const ROLE_MANDATOR_ADMIN = "ROLE_MANDATOR_ADMIN";
export const ROLE_MANDATOR_CREDENTIALS = "ROLE_MANDATOR_CREDENTIALS";
export const ROLE_ROLE_MANAGEMENT = "ROLE_ROLE_MANAGEMENT";
export const ROLE_IMPERSONATE = "ROLE_IMPERSONATE";
export const ROLE_MANDATOR_SCOPED_IMPERSONATE =
  "ROLE_MANDATOR_SCOPED_IMPERSONATE";

export const ACADEMIC_TITLE_NONE = "Kein Titel";

export const DEFAULT_CURRENCY = "EUR";
